import { useMemo } from 'react';
import { usePermissions } from 'react-admin';
import { ResourceAction, userIsAllowed } from '../Providers/AppPermissionsProvider';
import { User } from '../types/user.type';

export const useUserIsAllowed = (action: ResourceAction, resource = ''): boolean => {
  const { permissions: user } = usePermissions<User>();
  return useMemo(() => userIsAllowed(action, resource, user), [action, resource, user]);
};
